<script setup lang="ts">
import type { GroupEntry } from "@innoclouds/db";
import { useTranslation } from "i18next-vue";
import { useTemplateRef, watch } from "vue";
import { usePdf } from "#/composables/usePdfMode";
import { vDragScroll } from "#/directives/vDragScroll";
import UseScrollCenter from "#/hooks/useScrollToCenter/UseScrollCenter.vue";
import { getLocaleName } from "#/utils/i18next";

const props = defineProps<{
	items: GroupEntry[];
	activeId: GroupEntry["id"] | null;
}>();

const emit = defineEmits<{
	"select-item": [id: GroupEntry["id"], index: number];
}>();

const { shouldUseDragScroll } = usePdf();
const scrollGroup = useTemplateRef("scrollGroup");

const { i18next } = useTranslation();

watch(
	() => props.activeId,
	() => {
		const targetElement = scrollGroup.value?.querySelector(`#scrolling${props.activeId}`);
		if (targetElement) targetElement.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
	},
);
</script>

<template>
	<ul v-if="items?.length" class="main__menu" ref="scrollGroup" v-drag-scroll="shouldUseDragScroll ? {} : false">
		<UseScrollCenter axis="x" behavior="smooth" :container="scrollGroup" :autoScroll="true" :idActive="activeId" :clearContainer="true">
			<li
				v-for="(group, index) in items"
				:key="group.id"
				:id="`scrolling${group.id}`"
				@click="emit('select-item', group.id, index)"
				:style="activeId === group.id ? { fontFamily: 'var(--fontMain)', fontWeight: 'var(--fontWeightActive, normal)' } : {}"
			>
				{{ getLocaleName(group, i18next.language) }}
			</li>
		</UseScrollCenter>
	</ul>
</template>

<style scoped lang="scss">
  @use './groupMain.scss';
</style>
